class PaymentMethodPageTransform {
  constructor() {
    "ngInject";
  }
}

export default PaymentMethodPageTransform;



// WEBPACK FOOTER //
// ./src/pages/paymentMethod/paymentMethod.transforms.js